import styled from "@emotion/styled";
import { Checkbox, EditModal, Input, Title } from "@src/components";
import { DeungiDetailList } from "@src/interfaces/User.interface";
import React, { Dispatch, SetStateAction, useEffect, useState } from "react";

interface UserDeungiRefundModalProps {
    setIsDeungiRefundModalShow: Dispatch<SetStateAction<boolean>>;
    isModalShow: boolean;
    deungiTicket: DeungiDetailList;
    setDeungiRefundPrice: Dispatch<SetStateAction<string>>;
    deungiRefundPrice: string;
    setDeungiType: Dispatch<SetStateAction<string>>;
    setIsCheckModalShow: Dispatch<SetStateAction<boolean>>;
    setReason: Dispatch<SetStateAction<string>>;
    reason: string;
    isCheckModalShow: boolean;
}

const UserDeungiRefundModal = ({
    setIsDeungiRefundModalShow,
    isModalShow,
    deungiTicket,
    deungiRefundPrice,
    setDeungiRefundPrice,
    setDeungiType,
    setIsCheckModalShow,
    setReason,
    reason,
    isCheckModalShow,
}: UserDeungiRefundModalProps) => {
    const { productName, paidPrice, usedQuantity, refundQuantity } =
        deungiTicket;

    return (
        <>
            <EditModal
                isModalShow={isModalShow}
                buttonText="저장"
                handleBtnClick={() => {
                    setIsCheckModalShow(true);
                    setDeungiType("refund");
                }}
                handleOpenModal={() => {
                    setIsDeungiRefundModalShow(false);
                }}
                size="big"
                title="실시간 등기열람권 환불"
                isDisabled={
                    !deungiRefundPrice ||
                    !reason ||
                    Boolean(!refundQuantity && deungiRefundPrice === "0")
                }
            >
                <StyledWrap>
                    <StyledContens>
                        <div className="row">
                            <div>
                                충전정보 <span>{productName} 충전</span>
                            </div>
                            <div>
                                결제액 <span>{paidPrice.toLocaleString()}</span>
                            </div>
                        </div>
                        <div className="row">
                            <div>
                                사용 수량<span>{usedQuantity}</span>
                            </div>
                        </div>
                    </StyledContens>
                    <StyledRefundInfo>
                        <Title title="환불정보" />
                        <div className="row">
                            <div>
                                환불 수량 <span>{refundQuantity}</span>
                            </div>
                            <div>
                                <span className="star">*</span>환불예정액{" "}
                                <Input
                                    errorMessage=""
                                    handleChange={(e) => {
                                        const onlyNumber =
                                            e.target.value.replace(
                                                /[^0-9]/g,
                                                "",
                                            );
                                        setDeungiRefundPrice(onlyNumber);
                                    }}
                                    onKeyDown={function noRefCheck() {}}
                                    placeholder="금액 입력"
                                    size="medium"
                                    type="text"
                                    value={deungiRefundPrice}
                                />
                                <Checkbox
                                    defaultValue=""
                                    handleChange={(key, check) => {
                                        check &&
                                            paidPrice &&
                                            setDeungiRefundPrice(
                                                String(paidPrice),
                                            );
                                    }}
                                    label="전액환불"
                                />
                            </div>
                        </div>
                        <StyledReasonWrapper>
                            <span>
                                <span className="essential">*</span>사유
                            </span>
                            <input
                                type="text"
                                placeholder="사유를 작성해 주세요"
                                onChange={(e: any) => {
                                    setReason(e.target.value);
                                }}
                                value={reason}
                            />
                        </StyledReasonWrapper>
                    </StyledRefundInfo>
                </StyledWrap>
            </EditModal>
        </>
    );
};

export default UserDeungiRefundModal;

const StyledWrap = styled.div`
    display: flex;
    flex-direction: column;
    gap: 35px;
`;

const StyledContens = styled.div`
    display: flex;
    flex-direction: column;
    gap: 35px;
    & > .row {
        display: flex;
        & > div {
            width: 50%;
            & > span {
                margin-left: 15%;
            }
        }
    }
`;

const StyledRefundInfo = styled.div`
    margin-bottom: 25px;
    & > .row {
        display: flex;
        margin-top: 15px;
        & > div {
            width: 50%;
            display: flex;
            align-items: center;
            & > .star {
                color: #f45b5b;
                margin-left: 0;
            }
            & > span {
                margin-left: 15%;
            }

            & > input {
                margin-left: 20px;
                width: 50%;
                margin-right: 10px;
            }
        }
    }
`;

const StyledReasonWrapper = styled.div`
    position: absolute;
    bottom: 20px;
    width: 648px;
    height: 48px;
    display: flex;
    gap: 16px;
    align-items: center;
    & > span {
        font-weight: 400;
        font-size: 13px;
        width: 80px;
        .essential {
            color: #f45b5b;
        }
    }
    & > input {
        height: 100%;
        width: calc(100% - 296px);
        padding: 12px;
        font-weight: 400;
        font-size: 14px;
        line-height: 170%;
        color: #283237;
        border: 1px solid #e3e3e6;
        border-radius: 8px;
        outline: none;
    }
`;
